<template>
  <div class="appBody bg-grey-light">
    <little-header></little-header>
    <div class="ml-12 mr-12 mt-12p images"
         v-if="!isLoading">
    <div v-if="obj.status && obj.status===projectCertificateStatusEnum.finished">
      <pdf
        v-for="i in pageTotalNum"
        :key="i"
        :src="pdfSrc"
        :page="i"
        @page-loaded="curPageNum=$event"
        @link-clicked="page = $event"
      >
      </pdf>
    </div>
      <van-empty v-else :description="pdfSrc"/>
    </div>
    <van-loading class="my-5" v-else size="24px" vertical>加载中...</van-loading>
    <little-footer></little-footer>
  </div>
</template>

<script>
  import pdf from "vue-pdf";
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";
  import {mapState} from "vuex";
  import Vue from 'vue';
  import {Loading, Empty} from 'vant';

  Vue.use(Loading);
  Vue.use(Empty);
  export default {
    name: "certificatePage",
    data() {
      return {
        pdfSrc: '',
        isLoading: true,
        userId: '',
        projectId: '',
        obj: {},
        text: '',

        pageNum: 1,       // pdf文件页码
        pageTotalNum: undefined,
        curPageNum: 0,
        fileType: 'pdf',
      }
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl,
        projectCertificateStatusEnum: state => state.ProjectCertificateStatusEnum
      })
    },
    mounted() {
      this.userId = this.$route.params['userId'];
      this.projectId = this.$route.params['proId'];
      this.loadData();
    },
    components: {
      LittleHeader,
      littleFooter,
      pdf
    },
    methods: {
      loadData() {
        this.isLoading = true;
        this.$store.dispatch('getCertificateById', {projectId: this.projectId, userId: this.userId}).then(
          (res) => {
            if (res) {
              this.obj = res;
              this.isLoading = false;
              if (res.status && res.status === this.projectCertificateStatusEnum.finished) {
                this.loadPdf();
              } else if (res.status && res.status === this.projectCertificateStatusEnum.process) {
                this.pdfSrc = '学时证明正在处理中';
              } else {
                this.pdfSrc = '获取学时证明出错了';
              }
            }
          }
        );
      },
      loadPdf() {
        this.pdfSrc = pdf.createLoadingTask(this.uploadresUrl + this.obj.proveUrl);
        if (this.pdfSrc) {
          this.pdfSrc.promise.then(pdf => {
            this.pageTotalNum = pdf.numPages;
          }).catch((err) => {
            console.log(err);
          });

        }

      },
    }
  }
</script>

<style scoped>

</style>
